// What day it is, here.
//
// The arithmetic — the UTC grid, `endOfMonth`, `dayOfMonth`, and the Default
// Balance Date resolution — is `core/src/calendar.rs` (#214); this is the one
// clock reader.
//
// ── It stays in JavaScript because a core function must not have a clock ────
//
// Everything in the core is a *function of its arguments* — give
// `resolve_balance_date` a setting and a date and it answers the same way on
// any machine. `todayISO` asks the host what day it is where the user is
// sitting, and a pure core has no host to ask. (`queue.rs` likewise refuses an
// enqueue-resolved `serverTimestamp` by name — `RESOLVED_TIMESTAMP` — so a
// device clock is not written into a document.)
//
// So the rule: **a function of its arguments crosses; a function of its
// environment does not.**
//
// ── Why this one value is not read off the UTC grid ─────────────────────────
//
// Every other date-only value is built on `Date.UTC`, because one built in
// local time lands a day early west of Greenwich (CLAUDE.md).
//
// Today is the exception. "What date is it?" is a question about the teacher's
// wall clock, not about UTC: at 7pm in California the UTC date is already
// tomorrow. So this reads the *local* fields — `getFullYear`, `getMonth`,
// `getDate` — and formats them by hand.
const pad = (n) => String(n).padStart(2, '0');

export function todayISO(now = new Date()) {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
